import enumToOptions from '~/utils/enumToOptions';
import { Timezone } from '~/types';

export const timezoneOptions = enumToOptions(Timezone);

export default {};
